export default class SoundManager {
    private static btnSoundData = new Audio(require('../../public/assets/sounds/fart_buton_1.mp3')); // path to file
    private static loopBGM = new Audio(require('../../public/assets/sounds/main.mp3')); // path to file
    //private static loopEnding = new Audio(require('../../public/assets/sounds/ending.mp3')); // path to file
    public static btnSound() {
        this.btnSoundData.play();
    }
    public static loadCheck() {
        this.loopBGM.preload = "auto";
        this.btnSoundData.preload = "auto";
    }
    public static playBGM() {
        this.loopBGM.pause();
        //this.loopEnding.pause();
        this.loopBGM.loop = true;
        this.loopBGM.play();
    }
    public static stopBGM() {
        this.loopBGM.pause();
        //this.loopEnding.pause();
        //this.loopBGM.loop = true;
        //this.loopBGM.play();
    }
    public static playEnding() {
        this.loopBGM.pause();
        //this.loopEnding.pause();
        //this.loopEnding.loop = true;
        //this.loopEnding.play();
    }
    public static playOnce(key:string){
        this.soundData[key].play();
    }
    private static soundData: any = {
        cow_1: new Audio(require('../../public/assets/sounds/cow_1.mp3')),
        cow_2: new Audio(require('../../public/assets/sounds/cow_2.mp3')),
        cow_3: new Audio(require('../../public/assets/sounds/cow_3.mp3')),
        cat_1: new Audio(require('../../public/assets/sounds/cat_1.mp3')),
        cat_2: new Audio(require('../../public/assets/sounds/cat_2.mp3')),
        cat_3: new Audio(require('../../public/assets/sounds/cat_3.mp3')),
        human_1: new Audio(require('../../public/assets/sounds/human_1.mp3')),
        human_2: new Audio(require('../../public/assets/sounds/human_2.mp3')),
        human_3: new Audio(require('../../public/assets/sounds/human_3.mp3')),
        tree_1: new Audio(require('../../public/assets/sounds/tree_1.mp3')),
        tree_2: new Audio(require('../../public/assets/sounds/tree_2.mp3')),
        tree_3: new Audio(require('../../public/assets/sounds/tree_3.mp3')),
        frog_1: new Audio(require('../../public/assets/sounds/frog_1.mp3')),
        frog_2: new Audio(require('../../public/assets/sounds/frog_2.mp3')),
        frog_3: new Audio(require('../../public/assets/sounds/frog_3.mp3')),
        flower_1: new Audio(require('../../public/assets/sounds/flower_1.mp3')),
        flower_2: new Audio(require('../../public/assets/sounds/flower_2.mp3')),
        flower_3: new Audio(require('../../public/assets/sounds/flower_3.mp3')),
        bird_1: new Audio(require('../../public/assets/sounds/bird_1.mp3')),
        bird_2: new Audio(require('../../public/assets/sounds/bird_2.mp3')),
        bird_3: new Audio(require('../../public/assets/sounds/bird_3.mp3')),
        fart_1: new Audio(require('../../public/assets/sounds/fart_1.mp3')),
        fart_2: new Audio(require('../../public/assets/sounds/fart_2.mp3')),
        fart_3: new Audio(require('../../public/assets/sounds/fart_3.mp3')),
        fart_4: new Audio(require('../../public/assets/sounds/fart_4.mp3')),
        fart_5: new Audio(require('../../public/assets/sounds/fart_5.mp3')),
        fart_6: new Audio(require('../../public/assets/sounds/fart_6.mp3')),

    }
    private static logoSoundData = [
        'bird',
        'cat',
        'cow',
        'flower',
        'frog',
        'human',
        'tree'
    ];
    public static logoSound() {
        this.soundData[this.logoSoundData[this.randomIntFromInterval(0, this.logoSoundData.length - 1)] + "_" + this.randomIntFromInterval(1, 3)].play();
    }
    public static randomIntFromInterval(min: number, max: number) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min);
    }
}
